import {Contacts} from '../shared/model/interfaces';


export function extractContacts(data: any): Contacts {
  return {
    WpCompanyEmail: data.WpCompanyEmail,
    WpCompanyName: data.WpCompanyName,
    WpCompanyPhone: data.WpCompanyPhone,
    WpCompanyWebsite: data.WpCompanyWebsite,
    WpContactAddress1: data.WpContactAddress1,
    WpContactAddress2: data.WpContactAddress2,
    WpContactAddress3: data.WpContactAddress3,
    WpContactAddress4: data.WpContactAddress4,
    WpContactEmail: data.WpContactEmail,
    WpContactPhone: data.WpContactPhone,
    WpContactFax: data.WpContactFax,
    WpIrEmail: data.WpIrEmail
  };
}

export function toUpperCase(value: string): string {
  return value ? value.toUpperCase() : '';
}

export function getErrorMessageText(error: any, defaultErrorText?: string): string {
  if (error && error.error.error_description) {
    return error.error.error_description;
  } else if (error && error.error.Message) {
    return error.error.Message;
  } else {
    return defaultErrorText || 'Request failed';
  }
}
